import { useQuery } from "@apollo/client/react"; import React, { useEffect, useState, useMemo } from 'react';
import { Grid } from '@mui/material';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import './stepCondicionesGenerales.scss';

const inicioDeServicioDisplayNameAux = '¿El paciente requiere Soporte Nutricional?';

export const StepCondicionesGenerales = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI,
  pantallas,
  programOnlyCP
}) => {

  const [condicionesGenerales, setCondicionesGenerales] = useState(fullFormDataRI?.condicionesGenerales1 ?? {});
  const [combosRI, setCombosRI] = useState();

  const handleSubmit = () => {
    updateFormData('condicionesGenerales1', condicionesGenerales, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setCondicionesGenerales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const getOptionsByName = (fieldName) => {
    const combos = {
      'idComboRIValorFasePaciente': combosRI?.idComboRIValorFasePaciente,
      'buenaTolerancia': multipleBoolean,
      'inicioDeServicio': multipleBoolean
    };

    return combos[fieldName] || [];
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const validatedinputsGroups = useMemo(() => {
    const idPantallaDI = pantallas.find((p) => p.displayName.includes('DI'))?.id;
    const hasProgramDI = selectedPrograms?.indexOf(idPantallaDI) > -1;

    const updatedRequired = structuredClone(inputsGroups).map((group) => ({
      ...group,
      inputs: group.inputs.map((prevInput) => {
        const isNotRequired = hasProgramDI && notRequiredInDI.includes(prevInput.name);
        const input = {
          ...prevInput,
          required: isNotRequired ? false : prevInput.required,
          options: prevInput.type === 'select' || prevInput.type.includes('multiple') ? getOptionsByName(prevInput.name) : []
        };

        switch (input.name) {
          case 'buenaTolerancia':
          case 'continuarOtroTratamiento':
          case 'idComboRIValorFasePaciente':
            return {
              ...input,
              hidden: programOnlyCP,
              required: !programOnlyCP && input.required
            };
          case 'descOtroTratamiento':
            return {
              ...input,
              hidden: programOnlyCP,
              required: !programOnlyCP && condicionesGenerales.continuarOtroTratamiento
            };
          case 'inicioDeServicio':
            if (condicionesGenerales.buenaTolerancia === 'NO' && condicionesGenerales.inicioDeServicio === 'SI')
              handleChange(input.name);
            return {
              ...input,
              displayName: programOnlyCP ? inicioDeServicioDisplayNameAux : input.displayName,
              options: input.options.map((option) => ({
                ...option,
                disabled: condicionesGenerales.buenaTolerancia === 'NO' && option.label === 'SI'
              }))
            };
          case 'justificacionNoInicio':
            const inicioDeServicioEsNo = condicionesGenerales.inicioDeServicio === 'NO';
            if (!inicioDeServicioEsNo) handleChange(input.name);
            return {
              ...input,
              required: inicioDeServicioEsNo,
              disabled: !inicioDeServicioEsNo
            };
          default:
            return input;
        }
      })
    }));

    return updatedRequired;
  }, [
    selectedPrograms,
    condicionesGenerales.inicioDeServicio,
    condicionesGenerales.continuarOtroTratamiento,
    condicionesGenerales.buenaTolerancia,
    combosRI,
    programOnlyCP]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [condicionesGenerales, setDataSubmissionCallback, validatedinputsGroups]);

  useEffect(() => {
    if (!programOnlyCP) return;
    setCondicionesGenerales((prevDatos) => ({
      ...prevDatos,
      buenaTolerancia: null,
      continuarOtroTratamiento: false,
      descOtroTratamiento: null,
      idComboRIValorFasePaciente: null
    }));
  }, [programOnlyCP]);

  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid
            container>
            {group.inputs.
              filter((input) => !input.hidden).
              map((input) => {
                return (
                  <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={handleChange}
                    input={input}
                    value={condicionesGenerales[input.name]} />);


              })}
          </Grid>
        </div>
      )
      }
    </div>);

};

export default StepCondicionesGenerales;

const notRequiredInDI = [
  'continuarOtroTratamiento',
  'descOtroTratamiento',
  'idComboRIValorFasePaciente'];


const multipleBoolean = [
  { value: 'SI', label: 'SI' },
  { value: 'NO', label: 'NO' },
  { value: 'NA', label: 'NA' }];


const inputsGroups = [
  {
    groupName: 'Condiciones del paciente para el inicio',
    inputs: [
      {
        displayName: 'Buena tolerancia al volumen y ritmo de infusión:',
        name: 'buenaTolerancia',
        type: 'multiple_boolean',
        options: [],
        required: true
      },
      {
        displayName: 'Debe continuar con otros tratamientos?',
        name: 'continuarOtroTratamiento',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Indicar cual?',
        name: 'descOtroTratamiento',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Al momento de confeccionar este documento el paciente se encuentra en condiciones de iniciar el SND?',
        name: 'inicioDeServicio',
        type: 'multiple_boolean',
        required: true,
        options: []
      },
      {
        displayName: 'Justificar el NO',
        name: 'justificacionNoInicio',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'El paciente posee dispositivos para telemedicina?',
        name: 'dispositivoParaVideoConf',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Fase del paciente al inicio',
        name: 'idComboRIValorFasePaciente',
        comboName: 'Fase del paciente Inicio',
        type: 'select',
        options: [],
        required: true
      }]

  }];